import { sendRequest,sendRequestProtocols } from "../axios";
import {getcurrentURL} from '../components/api/localglobal'
export default {
  state: {
    calculationsData: [],
    allCalculationData: []
  },
  mutations: {
    SET_CALCULATIONS_DATA(state, commit) {
      state.calculationsData = commit;
    },
    SET_All_CALCULATIONS_DATA(state, commit) {
      state.allCalculationData = commit;
    }
  },
  actions: {
    deleteMyCalculation({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          "api/deleteMyCalculation/" + data,
          "delete",
          undefined,
          reject
        ).then(response => {
          commit("SET_CALCULATIONS_DATA", response.data.calculationsData);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getMyCalculationsData({ commit },payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        // OLD
        // sendRequest("api/MyCalculationsData", "get").then(response => {
        //   commit("SET_CALCULATIONS_DATA", response.data.calculationsData);
        //   commit("SET_PROCESSING", false);
        //   resolve(response);
        // });
        sendRequestProtocols(`calcregister/my`, "post",payload).then(response => {
          // commit("SET_CALCULATIONS_DATA", response.data);
          commit("SET_PROCESSING", false);
          resolve(response.data);
        });
      });
    },
    getAllUsersCalculationsData({ commit },payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        // sendRequest("api/AllUsersCalculationsData", "get").then(response => {
        //   const calcs = response.data.calculationsData;
        //   let result = [];
        //   for (let item in calcs) {
        //     result = [...result, ...calcs[item]];
        //   }
        //
        //   commit("SET_All_CALCULATIONS_DATA", result);
        //   commit("SET_PROCESSING", false);
        //   resolve(response);
        // });
        sendRequestProtocols(`calcregister/all`, "post",payload).then(response => {
          // commit("SET_All_CALCULATIONS_DATA", response.data);
          commit("SET_PROCESSING", false);
          resolve(response.data);
        });
      });
    }
  },
  getters: {
    getCalculationsData: state => state.calculationsData,
    getAllCalculationsData: state => state.allCalculationData
  }
};
